var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGameVolatilitySlow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    style: {
      clipRule: "evenodd",
      fillRule: "evenodd",
      imageRendering: "optimizeQuality",
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision"
    },
    viewBox: "0 0 3527.7802 1976.0401",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g1024",
    transform: "translate(-352.77,-1128.64)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor"
    },
    d: "m 586.82,1500.17 892.07,1452.68 c 58.31,94.38 161.34,151.83 272.28,151.83 176.77,0 320.07,-143.29 320.07,-320.06 0,-88.67 -36.79,-173.37 -101.59,-233.9 z m 1158.36,1085.88 c -111.13,0 -201.23,90.09 -201.23,201.23 0,111.14 90.1,201.23 201.23,201.23 111.14,0 201.23,-90.09 201.23,-201.23 0,-111.14 -90.09,-201.23 -201.23,-201.23 z",
    id: "path1020"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor"
    },
    d: "m 3880.55,2707.82 c 0,28.3 -0.85,56.59 -2.55,84.86 l -649.75,0.1 c -45.34,-744.92 -675,-1326.27 -1436.47,-1326.27 -252.44,0 -490.37,63.96 -697.35,176.53 L 943.46,1528.71 c 311.75,-248.8 722.71,-400.07 1173.2,-400.07 974.17,0 1763.89,707.02 1763.89,1579.18 z M 656.95,2009.63 c -173.65,217.93 -283.64,487.65 -301.63,783.15 -1.7,-28.3 -2.55,-56.63 -2.55,-84.96 0,-291.49 88.29,-564.5 242.14,-798.84 z",
    id: "path1022"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGameVolatilitySlow);
export default __webpack_public_path__ + "static/media/icon-game-volatility-slow.9d347fee63ba94864304d116c2d05701.svg";
export { ForwardRef as ReactComponent };